// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3q-qF","header":"Messages_header__oEVH3"};